import React from 'react'
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useNavigate } from 'react-router';
import { HOME, INVOICE } from '../../../services/UserRoutePath';
import '../../css/Login.css';
import '../../css/SuccessPage.css';

const SucessfullPage = () => {
    const navigate = useNavigate()
    return (
        <>
            <div className="success-page-wrapper">
                <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
                    <div className="row justify-content-center w-100">
                        <div className="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-10">
                            <div className="success-page-content">
                                <div className="success-card card">
                                    <div className="card-body text-center">
                                        {/* Success Status Badge */}
                                        <div className="success-status-badge">
                                            Request Submitted
                                        </div>

                                        {/* Success Icon */}
                                        <div className="mb-4">
                                            <div 
                                                className="success-icon-container success-icon-overlay d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                                style={{ 
                                                    width: "80px", 
                                                    height: "80px"
                                                }}
                                            >
                                                <AiOutlineCheckCircle 
                                                    style={{ 
                                                        fontSize: "36px", 
                                                        color: "white" 
                                                    }} 
                                                />
                                            </div>
                                        </div>

                                        {/* Success Title */}
                                        <h4 className="success-title success-title-text">
                                            Success!
                                        </h4>

                                        {/* Success Message */}
                                        <p className="success-message success-message-text">
                                            We received your invoice request successfully. 
                                            Our team will review it and be in touch shortly!
                                        </p>

                                        {/* Success Details */}
                                        <div className="success-alert alert mb-4">
                                            <div className="d-flex align-items-center">
                                                <AiOutlineCheckCircle className="me-2" style={{ fontSize: "16px" }} />
                                                <span>Your request has been submitted and is being processed</span>
                                            </div>
                                        </div>

                                        {/* What happens next info */}
                                        <div className="mb-4" style={{
                                            background: "rgba(99, 91, 255, 0.05)",
                                            border: "1px solid rgba(99, 91, 255, 0.1)",
                                            borderRadius: "8px",
                                            padding: "16px 20px",
                                            color: "#32325d",
                                            fontSize: "14px",
                                            fontWeight: "500"
                                        }}>
                                            <div className="mb-2" style={{ fontWeight: "600", color: "#635bff" }}>
                                                What happens next:
                                            </div>
                                            <div className="text-start">
                                                <div className="mb-1">• Our team will review your invoice within 24 hours</div>
                                                <div className="mb-1">• You'll receive an email confirmation shortly</div>
                                                <div>• We'll contact you if additional information is needed</div>
                                            </div>
                                        </div>

                                        {/* Action Button */}
                                        <button 
                                            className="success-primary-btn btn w-100 mb-3"
                                            onClick={() => navigate(HOME)}
                                        >
                                            Return to Dashboard
                                        </button>

                                        {/* Secondary Action */}
                                        <div className="text-center">
                                            <a 
                                                href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(INVOICE);
                                                }}
                                                className="success-secondary-link d-inline-block"
                                            >
                                                View Invoice History
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SucessfullPage